import { Pipe, PipeTransform } from '@angular/core';
import { Helper } from '../../classes/helper';

/*
 * Ensures a static asset path gets the right prefix
*/
@Pipe({name: 'staticp'})
export class StaticPathPipe implements PipeTransform {
  transform(value: string): string {
    return Helper.getStaticPathForResource(value);
  }
}
